<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Relatório de Prefixos Sem DIOs criados</h1>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>            
            </div>

            <!-- FILTROS -->            
            <div class="border-top px-1 py-3">
                <div class="row align-items-end">                      
                    <div class="col-6 col-md-6">
                        <div class="d-flex">
                            <mat-form-field class="flex-fill me-2">
                                <mat-label>Data</mat-label>
                                <input matInput [matDatepicker]="dataExecucao" name="inicio" #inicio="ngModel"
                                    autocomplete="off" [(ngModel)]="filters.dataExecucao">
                                <mat-datepicker-toggle matIconSuffix [for]="dataExecucao"></mat-datepicker-toggle>
                                <mat-datepicker #dataExecucao></mat-datepicker>
                            </mat-form-field>                                
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        
                    </div>
                    <div class="col-12 col-md-2 mx-auto">
                        <button mat-flat-button color="accent" class="w-100" (click)="search()">FILTRAR</button>
                    </div>
                </div>
            </div>
            
            <div class="overflow-x-auto">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Prefixo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of prefixos; let i = index" class="detail-row">
                            <td>{{ i + 1 }}</td>
                            <td>{{ item }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </mat-card-content>
    </mat-card>
</div>
